const CalendarYearSelect = ({ dateValues, changeCalendarDate }) => {
  const currentYear = dateValues.year;
  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  return (
    <select
      className="form-select year-select"
      aria-label="Year select"
      value={currentYear}
      onChange={(e) => changeCalendarDate(e.target.value, dateValues.month)}
    >
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>
  );
};

export default CalendarYearSelect;
